/* テンプレート一覧*/
import React, { memo } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

type Props = {
  templates: Array<Array<string>>;
  handleClickTemplateId: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

const ResultTemplateList: React.FC<Props> = ({ templates, handleClickTemplateId }) => {
  const columns: GridColDef[] = [
    {
      field: 'maintenance_id',
      headerName: 'テンプレートID',
      flex: 1,
      renderCell: (params) => (
        <a className="link-text" href={`/receptions/${params.row.maintenance_id}`}>
          {params.value}
        </a>
      ),
    },
    {
      field: 'display_name',
      headerName: 'テンプレート名',
      flex: 2,
    },
  ];

  return (
    <div id="result-template-list">
      <DataGrid
        getRowId={(row) => row?.maintenance_id}
        rows={templates}
        columns={columns}
        showColumnRightBorder
        showCellRightBorder
      />
    </div>
  );
};

export default memo(ResultTemplateList);
